import { render } from "./LearningQuizBox.vue?vue&type=template&id=2e71b08f&scoped=true"
import script from "./LearningQuizBox.vue?vue&type=script&lang=js"
export * from "./LearningQuizBox.vue?vue&type=script&lang=js"

import "./LearningQuizBox.vue?vue&type=style&index=0&id=2e71b08f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e71b08f"]])

export default __exports__